import React from "react";

const ReportStatus = ({data}) => {
  const {status} = data;
  if (status === "draft") {
    return (
      <span
        style={{
          borderRadius: "5px",
          backgroundColor: "#949494",
          color: "white",
          fontSize: "15px",
          padding: "5px 10px",
        }}
      >
        Draft
      </span>
    );
  } else if (status === "under-review") {
    return (
      <span
        style={{
          borderRadius: "5px",
          backgroundColor: "#ffc107",
          color: "white",
          fontSize: "15px",
          padding: "5px 10px",
        }}
      >
        Under Review
      </span>
    );
  } else {
    return (
      <span
        style={{
          borderRadius: "5px",
          backgroundColor: "#198754",
          color: "white",
          fontSize: "15px",
          padding: "5px 10px",
        }}
      >
        Submitted
      </span>
    );
  }
};

export default ReportStatus;
